module.exports = __webpack_public_path__ + "static/media/table.814e433d.png";